import { format } from "date-fns";
import { ROUTES, callAPI } from "../API/index";

// -----------------------------------------------
// Salary
// -----------------------------------------------
export const fetchSalaryManagement = (month, companyNo, employeeNo, paymentType, includeLeave = true) => {
    /**
     * 급여 관리 조회
     * @param {string} month - 조회할 월 (yyyy-MM 형식)
     * @param {string} companyNo - 회사 번호
     * @param {string} employeeNo - 직원 번호
     * @param {string} paymentType - 급여 형태
     * @param {boolean} includeLeave - 연차 계산 포함 여부 (기본값: true)
     */
    return callAPI(ROUTES.SALARY.MANAGEMENT, 'GET', {}, { month, companyNo, employeeNo, paymentType, include_leave: includeLeave });
}

export const fetchSalaryManagementList = (month, companyNo, employeeNos, paymentType) => {
    /**
     * 급여 관리 목록 조회
     */
    return callAPI(ROUTES.SALARY.MANAGEMENT, 'GET', {}, { month, companyNo, employeeNos, paymentType });
}

export const createSalaryManagement = (month, employeeNo, paymentType) => {
    /**
     * 급여 관리 생성
     */
    const apiData = {
        month: month,
        employeeNo: employeeNo,
        paymentType: paymentType
    }
    return callAPI(ROUTES.SALARY.MANAGEMENT, 'POST', apiData);
}

export const updateSalaryManagement = (apiData) => {
    /**
     * 급여 관리 수정
     */
    return callAPI(ROUTES.SALARY.MANAGEMENT, 'PUT', apiData);
}

export const deleteSalaryManagement = (apiData) => {
    /**
     * 급여 관리 삭제
     */
    return callAPI(ROUTES.SALARY.MANAGEMENT, 'DELETE', apiData);
}

export const createSalaryManagementAll = (month, companyNo, overwrite, paymentType) => {
    /**
     * 급여 관리 생성
     */
    const apiData = {
        month: month,
        companyNo: companyNo,
        updateAll: true,
        overwrite: overwrite,
        paymentType: paymentType
    }
    return callAPI(ROUTES.SALARY.MANAGEMENT, 'POST', apiData);
}

export const fetchPaymentList = (month, companyNo, employeeNos, paymentType) => {
    /**
     * 급여 내역 조회
     */
    return callAPI(ROUTES.SALARY.PAYMENT, 'GET', {}, { month, companyNo, employeeNos, paymentType });
}

export const fetchPaymentYearList = (year, paymentType, employeeNos) => {
    /**
     * 급여 내역 조회
     */
    const year_str = format(year, 'yyyy')
    const params = { year: year_str };
    
    // paymentType이 배열인 경우 쉼표로 구분된 문자열로 변환
    if (Array.isArray(paymentType) && paymentType.length > 0) {
        params.paymentType = paymentType.join(',');
    } else if (paymentType) {
        params.paymentType = paymentType;
    }
    
    // employeeNos 처리
    if (employeeNos && employeeNos.length > 0) {
        params.employeeNos = employeeNos;
    }
    
    return callAPI(ROUTES.SALARY.PAYMENT_YEAR_LIST, 'GET', {}, params);
}

export const fetchTransferList = (yearMonth, paymentType, employeeNos = []) => {
    /**
     * 급여 이체 내역 조회
     */
    const yearMonth_str = format(yearMonth, 'yyyyMM')
    const params = { yearMonth: yearMonth_str, paymentType };
    if (employeeNos && employeeNos.length > 0) {
        params.employeeNos = employeeNos.join(',');
    }
    return callAPI(ROUTES.SALARY.TRANSFER, 'GET', {}, params);
}

export const fetchLeavePaymentList = (year, paymentType) => {
    /**
     * 급여 내역 조회
     */
    const year_str = format(year, 'yyyy')
    return callAPI(ROUTES.SALARY.LEAVE.PAYMENT_LIST, 'GET', {}, { year: year_str, paymentType });
}

export const fetchCalcEncpnd = (type, encpnd, calcDate) => {
    /**
     * 연차 계산
     */
    return callAPI(ROUTES.SALARY.LEAVE, 'GET', {}, { type, encpnd, calcDate });
}

export const fetchRetirementPensionList = (yearMonth, emplNos = []) => {
    /**
     * 퇴직연금 내역 조회
     */
    yearMonth = format(yearMonth, 'yyyy-MM')
    const params = { yearMonth };
    if (emplNos && emplNos.length > 0) {
        params.employeeNos = emplNos.join(',');
    }
    return callAPI(ROUTES.SALARY.RETIREMENT_PENSION, 'GET', {}, params);
}

export const fetchRetirementPensionUpdate = (yearMonth, emplNos = []) => {
    /**
     * 퇴직연금 내역 수정
     */
    yearMonth = format(yearMonth, 'yyyy-MM')
    const body = { yearMonth };
    if (emplNos && emplNos.length > 0) {
        body.employeeNos = emplNos.join(',');
    }
    return callAPI(ROUTES.SALARY.RETIREMENT_PENSION, 'PUT', body);
}

export const fetchDepartureList = (yearMonth) => {
    /**
     * 퇴직연금 내역 조회
     */
    yearMonth = format(yearMonth, 'yyyy-MM')
    return callAPI(ROUTES.SALARY.DEPARTURE, 'GET', {}, { yearMonth });
}

export const fetchInsuranceRate = () => {
    /**
     * 보험 공제율 조회
     */
    return callAPI(ROUTES.COMMON.INSURANCE_RATE, 'GET');
}

export const fetchSalaryLeaveList = (date) => {
    /**
     * 연차 목록 조회
     * @param {Date} date - 기준일(년·월·일)
     */
    const month = format(date, 'yyyy-MM')
    const year = format(date, 'yyyy')
    const day = format(date, 'dd')
    const baseDate = format(date, 'yyyy-MM-dd')
    return callAPI(ROUTES.SALARY.LEAVE, 'GET', {}, { month, year, day, baseDate });
}

export const fetchSalaryLeaveInfo = (year, month, employeeNo) => {
    /**
     * 연차 계산 정보 조회
     * @param {string} year - 조회할 년도 (yyyy 형식)
     * @param {string} month - 조회할 월 (yyyy-MM 형식)
     * @param {string} employeeNo - 직원 번호
     */
    return callAPI(ROUTES.SALARY.LEAVE, 'GET', {}, { year, month, employeeNo });
}

export const fetchAccountBookList = (yearMonth) => {
    /**
     * 전표 조회
     */
    yearMonth = format(yearMonth, 'yyyy-MM')
    return callAPI(ROUTES.SALARY.ACCOUNT_BOOK, 'GET', {}, { yearMonth: yearMonth });
}

export const fetchLaborCostStatementList = (date) => {
    /**
     * 노무비내역서 목록 조회
     * @param {Date} date - 조회할 날짜 (년월)
     */
    const month = format(date, 'yyyy-MM')
    const year = format(date, 'yyyy')
    return callAPI(ROUTES.SALARY.DAILY, 'GET', {}, { month, year });
}

export const updateLaborCostStatement = (date, rowData) => {
    /**
     * 노무비내역서 수정 저장
     * @param {Date} date - 조회할 날짜 (년월)
     * @param {Array} rowData - 수정된 데이터 배열
     */
    const month = format(date, 'yyyy-MM')
    const year = format(date, 'yyyy')
    return callAPI(ROUTES.SALARY.DAILY, 'POST', { rowData, month, year });
}

export const updateLaborCostStatementBatch = (date, data) => {
    /**
     * 노무비내역서 재계산
     * @param {Date} date - 조회할 날짜 (년월)
     * @param {Object} data - 갱신할 데이터
     */
    const month = format(date, 'yyyy-MM')
    const year = format(date, 'yyyy')
    return callAPI(ROUTES.SALARY.DAILY.BATCH, 'POST', { ...data, month, year });
}

export const fetchBatchUpdate = (data) => {
    /**
     * 전표 수정
     */
    return callAPI(ROUTES.SALARY.BATCH_UPDATE, 'POST', data);
}

export const recalculateLaborCostStatement = (data) => {
    /**
     * 노무비내역서 재계산 (단일 사원)
     * @param {Object} data - 재계산 요청 데이터 (employeeNo, month, totalEarnings, totWorkDays, paymentType)
     */
    return callAPI(ROUTES.SALARY.DAILY.RECALCULATE, 'POST', data);
}